import axios from "axios";
import router from "@/router";
import Qs from 'qs'
import {
	Dialog
} from 'vant';

import Vue from 'vue';

import store from '@/store/store.js'
import codeLogin from '@/components/common/codeLogin.vue';

const resourceDomain = "https://wenwu3.oss-cn-hangzhou.aliyuncs.com/"


// 正式服
const aPI_BASE_URL = "https://wap.wenwuwangke.com"

// 测试服
// const aPI_BASE_URL = "http://twap.wenwuwangke.com"

const baseUrl = "/wap-api";


// create an axios instance
const service = axios.create({
	//baseURL: "http://127.0.0.1", // url = base url + request url 正式环境
	baseURL: baseUrl,
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 100000 // request timeout
});

// request interceptor
service.interceptors.request.use(
	config => {

		config.headers["Device"] = "wap"; //此处是SX_VIDEO的WAP端
		let token = localStorage.getItem("token");
		if (token) {
			config.headers["Authorization"] = token;
		}
		return config;
	},
	error => {
		// do something with request error
		console.log(error); // for debug
		return Promise.reject(error);
	}
);

// response interceptor
service.interceptors.response.use(
	response => {
		const res = response.data;
		// 状态50001 表示 未登录
		if (res.code === 50001) {
			//clear之前分享页面需要保存
			//localStorage.clear();
			store.commit('userModule/SET_login_popup_show', true)
			
		} else if (res.code === 50006 || res.code === 50012 || res.code === 50008) { //他处登录
			Dialog.alert({
				title: '提示',
				message: '您的账号已失效，请重新登录'
			}).then(() => {
				store.commit('userModule/SET_login_popup_show', true)
			});
			return
			
		} else {
			if (response && response.headers && res) {
				res['headers'] = response.headers
			}
			return res;
		}
		// return Promise.reject(new Error(res.message || 'Error'))
	},
	error => {
		console.log("err" + error); // for debug
		return Promise.reject(error);
	}
)



service.get = function(url, data) {
	return service({
		url: url,
		method: "get",
		params: data
	})
}

/**普通FORM提交方式 */
service.post = function(url, data) {
	return service({
		url: url,
		method: "post",
		data: Qs.stringify(data)
	})
}
// 上传图片
service.upLoadImg = function(url, data) {
	return service({
		url: url,
		method: "post",
		data: data,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}
/**前端传递JSON数据到后台 后端需要@RequestBody获取 */
service.postJson = function(url, data) {
	return service({
		url: url,
		method: "post",
		data: data
	})
}

/**文件上传 */
service.postFile = function(url, data) {
	return service({
		url: url,
		method: "post",
		data: data,
		headers: {
			"Content-Type": "multipart/form-data"
		}
	})
}


service.getFile = function(url) {
	return service({
		url: url,
		method: "get",
		responseType: 'arraybuffer'
		//data: data
	})
}


service.resourceDomain = resourceDomain
service.aPI_BASE_URL = aPI_BASE_URL

export default service;